import { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { API } from "../../../global/global";

interface ImageUploadModalProps {
  show: boolean;
  onHide: () => void;
  idActividad: number;
  tipo: string;
  onSuccess?: () => void;
}

const ImageUploadModal = ({
  show,
  onHide,
  idActividad,
  tipo,
  onSuccess,
}: ImageUploadModalProps) => {
  const [files, setFiles] = useState<FileList | null>(null);
  const [uploading, setUploading] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string>("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!files || files.length === 0) {
      setErrorMsg("Selecciona al menos una imagen");
      return;
    }

    setUploading(true);
    setErrorMsg("");

    const formData = new FormData();
    
    Array.from(files).forEach((file) => {
      formData.append("photo[]", file);
    });

    const endpoints: Record<string, string> = {
      actividad: `/foto/actividad_foto/${idActividad}`,
      verificacion: `/foto/verificacion_foto/${idActividad}`,
      manipulacion: `/foto/manipulacion_foto/${idActividad}`,
    };

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API}${endpoints[tipo]}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      setUploading(false);

      if (!response.ok) {
        setErrorMsg("Error al subir las imágenes");
        return;
      }

      onSuccess?.();
      handleClose();
    } catch (err) {
      setUploading(false);
      setErrorMsg("Error al subir las imágenes");
    }
  };

  const handleClose = () => {
    setFiles(null);
    setErrorMsg("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Subir imágenes</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}
          <Form.Group>
            <Form.Label>Seleccionar imágenes</Form.Label>
            <Form.Control
              type="file"
              multiple
              accept="image/*"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setFiles(e.target.files)
              }
            />
            <Form.Text className="text-muted">
              Puedes seleccionar múltiples imágenes
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={uploading}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={uploading}>
            {uploading ? "Subiendo..." : "Subir"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ImageUploadModal;
